import React, { useState, useContext, createRef, useEffect } from 'react';
import { Header, Container, Segment, Sticky, Grid, Input, GridRow, Modal } from 'semantic-ui-react';
import { Button, Form, Icon, Dropdown, Divider, Transition } from 'semantic-ui-react';
import { Link, useParams, Redirect } from 'react-router-dom';
import { AppState } from '../../context';
import firebase from 'firebase/app';
import 'firebase/database';
import { dbFamMember, dbCaregivers, dbTasks, dbFamtoFam, dbPending } from '../../firebase';
import 'firebase/functions';
import SemanticDatepicker from 'react-semantic-ui-datepickers';

import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css';



const SecondTaskPage = () => {
  const someContext = useContext(AppState);
  let { userid } = useParams();

  const {
    task,
    setTask,
    time,
    setTime,
    duration,
    setDuration,
    taskDescription,
    setTaskdescription,
    importance,
    setImportance,
    frequency,
    setFrequency,
    familyMembers,
    setFamilyMembers,
    tasks,
    setTasks,
    setCaregivers,
    seniors,
    logged
  } = someContext;
  const [caregivers, setContextCare] = useState(""); // variable for all the caregivers
  const [famID, setFamID] = useState("") // primary family member id
  const [famtofam, setFamtofam] = useState("")

  var temp=new Date()

  const [currentDate, setNewDate] = useState(temp);
  const [date, setDate] = useState(new Date());

  const TestDate = () => {

    const onChange = (e, data) => {
      setNewDate(currentDate => data.value)
      console.log(data.value);
      console.log(currentDate)
      setDate(data.value);
      // console.log(data)
      // console.log()

    };
    return <SemanticDatepicker
      onChange={onChange}
      clearable={true}
      keepOpenOnClear={true}
      locale="en-US"
      value={date}
      
    />;
  };


  useEffect(() => {
    const handleData = snap => {
      if (snap.val()) setFamtofam(snap.val());
    }
    dbFamtoFam.on('value', handleData, error => alert(error));
    return () => { dbFamtoFam.off('value', handleData); };
  }, []);

  useEffect(() => {
    const handleData = snap => {
      if (snap.val()) setContextCare(snap.val());
    }
    dbCaregivers.on('value', handleData, error => alert(error));
    return () => { dbCaregivers.off('value', handleData); };
  }, []);

  useEffect(() => {
    const initialzeName = (snappy3) => {
      setFamID(snappy3.val()[userid].familyMembers);
    }
    dbFamMember.on('value', initialzeName, error => alert(error));
    return () => { dbFamMember.off('value', initialzeName) }
  }, []);


  const [caregiverID, setCaregiverID] = useState("None");
  const [secondID, setSecondID] = useState("None");
  const [boolfamorcare, setBoolfamorcare] = useState(false);
  const [seniorID, setSeniorID] = useState("None");
  const [seniorItems, setSeniorItems] = useState([]);
  const [items, setItems] = useState([]);
  const [opened, setOpened] = useState(true);
  const [opened2, setOpened2] = useState(true);
  const [message, setMessage] = useState({ to: '', body: '' });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(false);
  const [finalmsg, setFinalmsg] = useState({ to: '+12243073351', body: 'o' });
  const [isModalOpen, setIsModalOpen] = useState(null);
  const [unassigned, setUnassigned] = useState(false);
  var counter = 0;
  const Importance_Array = [
    {
      key: 0,
      text: "Low",
      value: "Low"
    },
    {
      key: 1,
      text: "Medium",
      value: "Medium"
    },
    {
      key: 2,
      text: "High",
      value: "High"
    },
  ]
  const Frequency_Array = [
    {
      key: 0,
      text: "Twice a Day",
      value: "Twice a Day"
    },
    {
      key: 1,
      text: "Everyday",
      value: "Everyday"
    },
    {
      key: 2,
      text: "Weekly",
      value: "Weekly"
    },
    {
      key: 3,
      text: "One-time",
      value: "One-time"
      
    },
    {
      key:4,
      text: "Other",
      value: "Other"
    }
  ]

  function updateCaregiverID() {
    if (opened) {
      if (familyMembers && caregivers) {
        familyMembers[famID]["caregivers"].map((input) => {
          setItems(items => [...items, {
            key: caregivers[input]["id"],
            text: caregivers[input]["firstName"] + " " + caregivers[input]["lastName"],
            value: caregivers[input]["id"]
          }])
        })
        if (familyMembers[famID]["secondaryFam"] !== "hi") {
          familyMembers[famID]["secondaryFam"].map((input) => {
            if (input != userid) {
              setItems(items => [...items, {
                key: input,
                text: familyMembers[input]["firstName"] + " " + familyMembers[input]["lastName"],
                value: input
              }])
            }
          })
          setItems(items => [...items, {
            key: famID,
            text: familyMembers[famID]["firstName"] + " " + familyMembers[famID]["lastName"],
            value: famID
          }])
          console.log([...items, {
            key: famID,
            text: familyMembers[famID]["firstName"] + " " + familyMembers[famID]["lastName"],
            value: famID
          }])

          setItems(items => [...items, {
            key: "unassigned",
            text: "Leave Unassigned",
            value: "unassigned"
          }])
        }
      }
      setOpened(false);
    }
  }
  function updateSeniorItems() {
    if (opened2) {
      if (familyMembers && seniors) {
        familyMembers[famID]["seniors"].map((input) => {
          setSeniorItems(seniorItems => [...seniorItems, {
            key: input,
            text: seniors[input]["firstName"] + " " + seniors[input]["lastName"],
            value: input
          }])
        })
      }
      setOpened2(false);
    }
  }
  // function sendMessage(event, input) {
  //   if (counter < 2) {
  //     event.preventDefault();
  //     counter = counter + 1;
  //   }
  //   else {
  //     event.returnValue = true;
  //   }
  //   setSubmitting(true);
  //   fetch('/api/messages', {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json'
  //     },
  //     body: JSON.stringify(input)
  //   })
  //     .then(res => res.json())
  //     .then(data => {
  //       if (data.success) {
  //         console.log("suceeded");
  //         console.log(data.body);
  //         console.log(JSON.stringify(input))
  //         setError(false);
  //         setSubmitting(false);
  //       } else {
  //         console.log("failed");
  //         console.log(data.body);
  //         console.log(JSON.stringify(input))
  //         setError(true);
  //         setSubmitting(false);
  //       }
  //     });
  // }

  const sendText = firebase.functions().httpsCallable('sendText');

  function addNewTask(event, caregiverID, seniorID) {
    setIsModalOpen(true);
    setSubmitting(true);

    if (boolfamorcare && !unassigned) {
      if (secondID != null) {
        const k = dbFamtoFam.push({
          "description": taskDescription.value || null,
          "duration": duration.value || null,
          "AssignedbyFam": userid || null,
          "frequency": frequency || null,
          "importance": importance || null,
          "status": false,
          "taskName": task.value || null,
          "time": time.value || null,
          "AssignedtoFam": secondID || "None",
          "seniorID": seniorID,
          "createdOn": { '.sv': 'timestamp' },
          "duebydate": currentDate.getTime()
        });

        let push = k.path['pieces_'][1];

        dbFamMember.child(userid).child("taskstofam").update({ //tasks basically means tasksbyme 
          [push]: push || null
        });
        dbFamMember.child(secondID).child("tasksfromfam").update({
          [push]: push || null
        });
      }
    }
    else if (!unassigned) {
      if (caregiverID != null) {
        const k = dbTasks.push({
          "description": taskDescription.value || null,
          "duration": duration.value || null,
          "familyMemberID": userid || null,
          "frequency": frequency || null,
          "importance": importance || null,
          "status": false,
          "taskName": task.value || null,
          "time": time.value || null,
          "caregiverId": caregiverID || "None",
          "seniorID": seniorID,
          "createdOn": { '.sv': 'timestamp' },
          "duebydate":currentDate.getTime()
        });

        let push = k.path['pieces_'][1];

        dbFamMember.child(userid).child("tasks").update({
          [push]: push || null
        });
        dbCaregivers.child(caregiverID).child("tasks").update({
          [push]: push || null
        });


        let c = "\nTask: " + task.value + "\nTime: " + time.value + "\nApproximate Duration: " + duration.value + "\nDescription: " + taskDescription.value + "\nImportance: " +
          importance.value + "\nFrequency: " + frequency.value;
        // setMessageBody(c); 
        var caregivername = " wrong";
        dbCaregivers.child(caregiverID).child("firstName").on("value", function (snapshot) {
          caregivername = snapshot.val()
        }, function (errorObject) {
          console.log("The read failed: " + errorObject.code);
        });
        var familyMemberName = "";
        dbFamMember.child(userid).child("firstName").on("value", function (snapshot) {
          familyMemberName = snapshot.val()
        }, function (errorObject) {
          console.log("The read failed: " + errorObject.code);
        });

        let messageee = "Congrats! You have added a task. " + caregivername + " will be notified!"
        var number = 0;
        var number2 = 0;
        dbFamMember.child(userid).child("phone").on("value", function (snapshot) {
          number = snapshot.val()

        }, function (errorObject) {
          console.log("The read failed: " + errorObject.code);
        });
        dbCaregivers.child(caregiverID).child("phone").on("value", function (snapshot) {
          number2 = snapshot.val()

        }, function (errorObject) {
          console.log("The read failed: " + errorObject.code);
        });

        let temp = { to: number, body: messageee };
        let temp2 = { to: number2, body: "Attention! " + familyMemberName + " has set a new task for you! Details as follow: " + c };
        sendText({ data: temp })
        sendText({ data: temp2 });
        event.returnValue = true;
      }
    }
    else {

      const k = dbPending.push({
        "description": taskDescription.value || null,
        "duration": duration.value || null,
        "AssignedbyFam": userid || null,
        "frequency": frequency || null,
        "importance": importance || null,
        "status": false,
        "taskName": task.value || null,
        "time": time.value || null,
        "AssignedtoFam": "None",
        "seniorID": seniorID,
        "createdOn": { '.sv': 'timestamp' },
        "duebydate": currentDate.getTime()
      })
      let push = k.path['pieces_'][1];
      if (dbFamMember.child(famID).child('unassignedTasks')) {
        dbFamMember.child(famID).child('unassignedTasks').update({
          [push]: push || null
        })
      }
    }
  }
  const contextRef = createRef();
  function SetFamCare(input) {
    if (familyMembers[input]) {
      setSecondID(input);
      setBoolfamorcare(true);
    }
    else if (caregivers[input]) {
      setCaregiverID(input);
      setBoolfamorcare(false);
    }
    else {
      setUnassigned(true);
    }
  }
  if (logged) {
    return (
      <div ref={contextRef}>
        <Container>
          <Divider hidden />
          <Modal open={isModalOpen} basic size='small' onClose={() => setIsModalOpen(false)}>
            <Header icon='send' content='Sent!' />
            <Modal.Content>
              <p>
                The notification was sent, do you want to go back to the Task List:
      </p>
            </Modal.Content>
            <Modal.Actions>
              <Button basic color='red' inverted onClick={() => setIsModalOpen(false)}>
                <Icon name='remove' /> No
      </Button>
              <Button color='green' inverted as={Link} to={`/viewfamily/${userid}`}>
                <Icon name='checkmark' /> Yes
      </Button>
            </Modal.Actions>
          </Modal>
          <br />
          <br />
          <Grid padded textAlign="center">
            <Grid.Row style={{ marginTop: "-5px" }}>
              <Form size="large">
                <Form.Group widths='equal'>
                  <Form.Input
                    onChange={(e) => { setTask({ value: e.target.value }) }}
                    id='form-subcomponent-shorthand-input-last-name'
                    label='Name of Task:'
                  // placeholder='Name of Task'
                  />
                </Form.Group>
              </Form>
            </Grid.Row>
            <Grid.Row style={{ marginTop: "-15px" }}>
              <Form size="large">
                <Form.Group widths='equal'>
                  <Form.Input
                    onChange={(e) => { setTime({ value: e.target.value }) }}
                    id='form-subcomponent-shorthand-input-first-name'
                    label='Time Due:'
                  // placeholder='Time'
                  />
                </Form.Group>
              </Form>
            </Grid.Row>
            <Grid.Row style={{ marginTop: "-15px" }}>
          <Form.Group  style={{marginTop:"-10px"}}>
          <Header as = "h4">Date Due:</Header>
            <TestDate />

          </Form.Group>
          </Grid.Row>
            <Grid.Row style={{ marginTop: "-15px" }}>
              <Form size="large">
                <Form.Group widths='equal'>
                  <Form.Input
                    onChange={(e) => { setTaskdescription({ value: e.target.value }) }}
                    id='form-subcomponent-shorthand-input-first-name'
                    label='Description:'
                  // placeholder='Description'
                  />
                </Form.Group>
              </Form>
            </Grid.Row>
            <Grid.Row style={{ marginTop: "-15px", marginLeft: "-120px" }}>
              <Header as="h4" content="Frequency:" />
            </Grid.Row>
            <Grid.Row style={{ marginTop: "-23px" }}>
              <Dropdown pointing="bottom"
                options={Frequency_Array}
                selection
                scrolling
                placeholder='Select Frequency'
                onChange={(e, { value }) => setFrequency(value)}
                upward={false}>
              </Dropdown>
            </Grid.Row>
            {/* <Grid.Row style={{ marginLeft: "-114px" }}>
              <Header as="h4" content="Importance:" />
            </Grid.Row> */}
            {/* <Grid.Row style={{ marginTop: "-23px" }}>
              <Dropdown pointing="bottom"
                options={Importance_Array}
                selection
                scrolling
                upward={true}
                placeholder='Select Importance'
                onChange={(e, { value }) => setImportance(value)}
              >
              </Dropdown>
            </Grid.Row> */}
            <Grid.Row style={{ marginLeft: "-122px" }}>
              <Header as="h4" content="Assign Task:" />
            </Grid.Row>
            <Grid.Row style={{ marginTop: "-23px" }}>
              <Dropdown pointing="bottom"
                options={items}
                selection
                scrolling
                upward={true}
                placeholder={familyMembers && famID ? <span>{familyMembers[famID]["secondaryFam"] != "hi" ? 'FamilyMember/Caregiver ' : 'Select Caregiver'}</span> : ""}
                onOpen={() => updateCaregiverID()}
                onChange={(e, { value }) => SetFamCare(value)}>
              </Dropdown>
            </Grid.Row>
            <Grid.Row style={{ marginLeft: "-145px" }}>
              <Header as="h4" content="Senior:" />
            </Grid.Row>
            <Grid.Row style={{ marginTop: "-23px" }}>
              <Dropdown pointing="bottom"
                options={seniorItems}
                selection
                scrolling
                upward={true}
                placeholder='Select Senior'
                onOpen={() => updateSeniorItems()}
                onChange={(e, { value }) => setSeniorID(value)}>
              </Dropdown>
            </Grid.Row>
            <Grid.Row style={{ marginTop: "5px" }}>
              <Button.Group>
                <Button icon labelPosition='left' as={Link} to={`/viewfamily/${userid}`} >Cancel<Icon name='cancel' /></Button>
                <Button color='green' icon labelPosition='right' onClick={(event) => addNewTask(event, caregiverID, seniorID)}>
                  Save
          <Icon name='checkmark' />
                </Button>
              </Button.Group>
            </Grid.Row>
          </Grid>
        </Container>
      </div>
    );
  }
  else {
    return (<Redirect to={'/familymembers'} push={true} />)
  }

}

export default SecondTaskPage;



